import { BACKEND_URL_PREFIX } from "../assets/const";

export const getInitials = (word1, word2) => {
    const letter1 = word1 && word1.split()[0]
    const letter2 = word2 && word2.split()[0]
    return `${letter1 || ''}${letter2 || ''}`.toUpperCase()
}

export function debounce(func, wait, immediate) {
  
  
  let timeout;
  
  return function executedFunction() {
    const context = this;
    const args = arguments;

    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};

export function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const getFileUrl = (fileName, mode) => {
  if (mode === 'resume') return `${BACKEND_URL_PREFIX}/resume/${fileName}`
  if (mode === 'transcription') return `${BACKEND_URL_PREFIX}/transcriptions/${fileName}/download`
  if (mode === 'record') return `${BACKEND_URL_PREFIX}/recordings/download/${fileName}`
}


export function getFilenameFromContentDisposition(disposition) {
  if (!disposition) return null;

  // Сначала пробуем filename*= (RFC 5987)
  const utf8FilenameMatch = disposition.match(/filename\*=utf-8''(.+?)(?:;|$)/i);
  if (utf8FilenameMatch) {
    try {
      return decodeURIComponent(utf8FilenameMatch[1]);
    } catch (e) {
      // fallback, если decodeURIComponent сломается (маловероятно)
    }
  }

  // Затем fallback на обычный filename= (может быть в кавычках)
  const asciiFilenameMatch = disposition.match(/filename=("?)(.*?)\1(?:;|$)/i);
  if (asciiFilenameMatch) {
    return asciiFilenameMatch[2];
  }

  return null;
}